import styled, { css } from 'styled-components';

import { Flex, Grid, List, mediaMixin, spaceMixin, Spacer, token } from '@zillow/constellation';

export const StyledContainerGrid = styled(Grid)`
  border-radius: 4px;
  display: grid;
  background-color: ${({ includeWhiteBackground }) => (includeWhiteBackground ? 'white' : 'none')};
  padding: ${({ noPadding }) => (noPadding ? 0 : '40px 16px')};
  margin: ${({ includeMargin }) => (includeMargin ? 0 : '0 -16px')};
  height: ${({ minMobileHeight }) => minMobileHeight && minMobileHeight};

  ${({ isResizing }) =>
    isResizing &&
    `
        animation: none !important;
        transition: none !important;
    `}

  ${mediaMixin(
    'md',
    css`
      margin: 0;
      padding: ${({ noPadding }: { noPadding: boolean }) => (noPadding ? 0 : '40px 24px')};
    `,
  )}

    ${mediaMixin(
    'xl',
    css`
      margin: 0;
      padding: ${({ noPadding }: { noPadding: boolean; minDesktopHeight: string }) => (noPadding ? 0 : spaceMixin(5))};
      height: ${({ minDesktopHeight }) => minDesktopHeight && minDesktopHeight};
    `,
  )}
`;

export const StyledGrid = styled(Grid)`
  align-content: start;
  background-color: ${({ noBackground }) => (noBackground ? 'none' : 'white')};
  display: grid;
  grid-column-end: ${({ mobileColSpan }) => `span ${mobileColSpan}`};
  padding: ${({ includePadding }) => includePadding && spaceMixin('xl')};
  overflow: ${({ noOverflow }) => (noOverflow ? 'none' : 'hidden')};

  ${mediaMixin(
    'lg',
    css`
      grid-column-end: ${({ tabletColSpan }: { tabletColSpan: number | string }) =>
        tabletColSpan && `span ${tabletColSpan}`};
    `,
  )}

  ${mediaMixin(
    'xl',
    css`
      grid-column-end: ${({ desktopColSpan }: { desktopColSpan: number | string }) => `span ${desktopColSpan}`};
    `,
  )}
`;

export const StyledMiddleLegendSpacer = styled(Spacer)`
  border-radius: 2px;

  ${mediaMixin(
    'xxl',
    css`
      margin: 0 ${spaceMixin('sm')};
    `,
  )};
`;

export const StyledFlexEndLegend = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: ${spaceMixin('md')};

  ${mediaMixin(
    'xxl',
    css`
      margin-left: auto;
      margin-top: ${spaceMixin(0)};
      justify-content: flex-end;
    `,
  )};
`;

export const StyledLegendKey = styled.div`
  border: ${({ color, lineStyle = 'solid' }: { color: string; lineStyle?: string }) => `2px ${lineStyle} ${color}`};
  border-radius: 2px;
  width: 20px;
  margin-right: ${spaceMixin(0.5)};

  ${mediaMixin(
    'lg',
    css`
      margin-right: ${spaceMixin('xs')};
    `,
  )};
`;

export const StyledLegend = styled(Flex)`
  flex-direction: column;
  padding-top: ${spaceMixin('sm')};
  padding-left: ${spaceMixin('lg')};

  ${mediaMixin(
    'xxl',
    css`
      flex-direction: row;
      padding-left: ${({ isInModal }: { isInModal: boolean }) => !isInModal && '60px'};
    `,
  )};
`;

export const StyledHR = styled.div`
  border-bottom: 1px solid ${token('colors.gray300')};
  border-right: none;
  margin-bottom: ${spaceMixin('lg')};
`;

export const StyledFixedHeightFlex = styled(Flex)`
  height: 300px;
`;

export const StyledNoPaddingListItem = styled(List.Item)`
  padding: 0;
`;

export const StyledCircle = styled.div`
  background-color: ${({ color }) => color || token('colors.yellow400')};
  border-radius: 4px;
  display: block;
  height: 8px;
  line-height: 8px;
  width: 8px;
`;
